// extracted by mini-css-extract-plugin
export default {"modal":"yO-z","sharingIconsV2":"zO-z","notificationBox":"AO-z","checkMark":"BO-z","textFrame":"CO-z"};